"use strict";
// THIS CODE WAS AUTOMATICALLY GENERATED
// DO NOT EDIT THIS CODE BY HAND
// RUN THE FOLLOWING COMMAND FROM THE WORKSPACE ROOT TO REGENERATE:
// npx nx generate-lib repo
Object.defineProperty(exports, "__esModule", { value: true });
exports.esnext = void 0;
const es2023_1 = require("./es2023");
const esnext_array_1 = require("./esnext.array");
const esnext_collection_1 = require("./esnext.collection");
const esnext_decorators_1 = require("./esnext.decorators");
const esnext_disposable_1 = require("./esnext.disposable");
const esnext_intl_1 = require("./esnext.intl");
const esnext_object_1 = require("./esnext.object");
const esnext_promise_1 = require("./esnext.promise");
const esnext_regexp_1 = require("./esnext.regexp");
const esnext_string_1 = require("./esnext.string");
exports.esnext = {
    ...es2023_1.es2023,
    ...esnext_intl_1.esnext_intl,
    ...esnext_decorators_1.esnext_decorators,
    ...esnext_disposable_1.esnext_disposable,
    ...esnext_promise_1.esnext_promise,
    ...esnext_object_1.esnext_object,
    ...esnext_collection_1.esnext_collection,
    ...esnext_array_1.esnext_array,
    ...esnext_regexp_1.esnext_regexp,
    ...esnext_string_1.esnext_string,
};
//# sourceMappingURL=esnext.js.map